import { styled } from 'styled-components';

import { Container, ContainerProps } from '@foradevelopment/fora-ui';

export const layoutSizeSettings = {
  maxWidth: [1236],
  padding: [20],
  removePadding: [-20, 0, 0],
};

const SectionLayoutContainer = styled(Container)`
  width: 100%;
  margin: 0 auto;
`;

export const SectionLayout = ({
  id,
  style,
  className,
  position,
  flexGrow,
  flexShrink,
  flexBasis,
  width,
  minWidth,
  height,
  minHeight,
  maxHeight,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  paddingTop,
  paddingBottom,
  background,
  backgroundColor,
  textAlign,
  initial,
  animate,
  variants,
  exit,
  transition,
  border,
  borderRadius,
  boxShadow,
  role,
  children,
  overflowY,
  overflowX,
}: ContainerProps) => {
  return (
    <SectionLayoutContainer
      paddingLeft={layoutSizeSettings.padding}
      paddingRight={layoutSizeSettings.padding}
      textAlign={textAlign}
      style={style}
      overflowY={overflowY}
      overflowX={overflowX}
      className={className}
      position={position}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      flexBasis={flexBasis}
      width={width}
      minWidth={minWidth}
      maxWidth={layoutSizeSettings.maxWidth}
      height={height}
      minHeight={minHeight}
      maxHeight={maxHeight}
      marginTop={marginTop}
      marginRight={marginRight}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundColor={backgroundColor}
      initial={initial}
      animate={animate}
      variants={variants}
      exit={exit}
      transition={transition}
      border={border}
      borderRadius={borderRadius}
      boxShadow={boxShadow}
      role={role}
      id={id}
    >
      {children}
    </SectionLayoutContainer>
  );
};
